<template>
  <Layout>
    <Content :style="{'padding': '10px'}">
      <Breadcrumb :style="{margin: '5px 0'}">
        <BreadcrumbItem >通用管理 > <b>渠道列表</b></BreadcrumbItem>
      </Breadcrumb>
      <Card>
       <p :style="{'margin':'5px 10px 10px 20px','clear':'both','overflow':'hidden'}">
			<span :style="{'text-align':'center','float':'left'}">
				<Button type='primary' :style="{'margin-left':'5px'}" @click="addChannel()">添加渠道</Button>
			</span>
        </p>
        <Card id="tableContent" >
          <Table :columns="tableColumns" :data="channel_list"></Table>
          <Page :total="recordTotal" :current="page" :page-size="15" :show-elevator="true" @on-change="getChannelList"/>
        </Card>
      </Card>
    </Content>
   <Modal v-model="showmodal" :footer-hide=true title="渠道" width="700">
        <Form ref="channel" :model="channel" :label-width="150" >
          <FormItem label="公司名称" prop="company_name">
            <Input v-model="channel.company_name"  />
          </FormItem>
          <FormItem label="公司简称" prop="company_short_name">
            <Input v-model="channel.company_short_name"  />
          </FormItem>
          <FormItem label="渠道英文名称" prop="e_name">
             <Input v-model="channel.e_name" placeholder="请输入小写拼音或英文名称,注意此名称为客户端小程序标识" />
          </FormItem>
          <FormItem label="渠道中文名称" prop="title">
            <Input v-model="channel.title"  />
          </FormItem>
			<FormItem label="跟进人" prop="incharge">
			  <Input v-model="channel.incharge"  />
			</FormItem>
          <FormItem label="公司简介" prop="公司简介">
            <Input v-model="channel.公司简介" type="textarea" :rows="4" />
          </FormItem>
          <FormItem label="帮助文档连接" prop="help">
            <Input v-model="channel.help"  />
          </FormItem>
          <FormItem label="渠道排序" prop="seq">
            <Input v-model="channel.seq"  />
          </FormItem>
          <FormItem label="有效期开始时间" prop="seq">
            <DatePicker type="date" placeholder="" style="width: 200px" v-model="channel.indate_start"></DatePicker>
          </FormItem>
          <FormItem label="有效期结束时间" prop="seq">
            <DatePicker type="date" placeholder="" style="width: 200px" v-model="channel.indate_end"></DatePicker>
          </FormItem>
          <FormItem label="企业LOGO" prop="cover">
            <img :src="channel.logo" :style="{'width':'100px'}"/>
            <Upload :action="getUploadUrl" :headers="uploadHeader" :on-success="successLogo">
              <Button icon="ios-cloud-upload-outline">上传企业LOGO</Button>
            </Upload>
          </FormItem>
          <FormItem label="企业登录LOGO" prop="cover">
            <img :src="channel.login_logo" :style="{'width':'100px'}"/>
            <Upload :action="getUploadUrl" :headers="uploadHeader" :on-success="successLoginLogo">
              <Button icon="ios-cloud-upload-outline">上传企业登录LOGO</Button>
            </Upload>
          </FormItem>
          <FormItem label="企业ico" prop="cover">
            <img  :src="channel.ico" :style="{'width':'100px'}"/>
            <Upload :action="getUploadUrl" :headers="uploadHeader" :on-success="successIco">
              <Button icon="ios-cloud-upload-outline">上传企业ico</Button>
            </Upload>
          </FormItem>
          <FormItem label="小程序登录LOGO" prop="cover">
            <img v-if="channel.mini_login_logo" :src="channel.mini_login_logo" :style="{'width':'100px'}"/>
            <Upload :action="getUploadUrl" :headers="uploadHeader" :on-success="successMiniLoginLogo">
              <Button icon="ios-cloud-upload-outline">上传小程序登录LOGO</Button>
            </Upload>
          </FormItem>
          <FormItem label="小程序首页图" prop="cover">
            <img v-if="channel.mini_home_logo" :src="channel.mini_home_logo" :style="{'width':'100px'}"/>
            <Upload :action="getUploadUrl" :headers="uploadHeader" :on-success="successMiniHomeLogo">
              <Button icon="ios-cloud-upload-outline">上传小程序首页图</Button>
            </Upload>
          </FormItem>
          <FormItem label="小程序分享左侧图片" prop="cover">
            <img v-if="channel.share_leftimg" :src="channel.share_leftimg" :style="{'width':'100px'}"/>
            <Upload :action="getUploadUrl" :headers="uploadHeader" :on-success="successShareLeft">
              <Button icon="ios-cloud-upload-outline">上传小程序分享左侧图片</Button>
            </Upload>
          </FormItem>
          <FormItem label="小程序分享封面图" prop="cover">
            <img v-if="channel.share_cover" :src="channel.share_cover" :style="{'width':'100px'}"/>
            <Upload :action="getUploadUrl" :headers="uploadHeader" :on-success="successShareCover">
              <Button icon="ios-cloud-upload-outline">上传小程序分享封面图</Button>
            </Upload>
          </FormItem>

          <FormItem label="用户协议" prop="user_agreement">
            <Upload
                :before-upload="handleAgreementUpload"
                action="//jsonplaceholder.typicode.com/posts/">
              <Button icon="ios-cloud-upload-outline">请选择新版本文件</Button>
            </Upload>
            <Progress :percent="upLoadAgreement" v-show="upLoadAgreement_show" />
            <div v-if="upLoadAgreementFile !== null">Upload file: {{ upLoadAgreementFile.name }} <Button type="text" @click="doAgreementUpload" :loading="loadingStatusFile">{{ loadingStatusFile ? '上传中...' : '点击上传' }}</Button></div>
          </FormItem>
          <FormItem label="隐私服务" prop="private_agreement">
				<Upload
					:before-upload="handleUpload"
					action="//jsonplaceholder.typicode.com/posts/">
					<Button icon="ios-cloud-upload-outline">请选择新版本文件</Button>
				</Upload>
				<Progress :percent="upLoadProgress" v-show="upLoadProgress_show" />
				<div v-if="file !== null">Upload file: {{ file.name }} <Button type="text" @click="doUpload" :loading="loadingStatus">{{ loadingStatus ? '上传中...' : '点击上传' }}</Button></div>
   			</FormItem>
        <FormItem label="相关配置" prop="cover">
          <Input v-model="channel.setting" type="textarea" :autosize="{minRows: 2,maxRows: 5}" placeholder="相关配置(json)"></Input>
        </FormItem>
		<FormItem label="模型价格" prop="model_price">
		  <Input v-model="channel.model_price" type="textarea" :autosize="{minRows: 2,maxRows: 5}" placeholder="模型价格(json)"></Input>
		</FormItem>
        <FormItem>
            <Button type="primary" @click="updateChannel()">提交</Button>
        </FormItem>
        </Form>
    </Modal>
    <Modal v-model="producetListModal" :footer-hide=true title="渠道管理/渠道列表/商品配置" :width="100">
      <Content :style="{'padding': '10px'}">
        <Breadcrumb :style="{margin: '5px 0'}">
          <BreadcrumbItem><b><</b></BreadcrumbItem>
          <BreadcrumbItem><b>商品配置</b></BreadcrumbItem>
        </Breadcrumb>
        <Card>
          <Card :style="{'padding':'0px 5px','margin-bottom':'5px'}">
          <span class="search_span_width">
                <span class="search_span_width_part1">版本号：</span>
              <Input v-model="search.app_version" placeholder="请输入版本号" clearable :style="{'width':'110px'}"></Input>
            </span>
            <span class="search_span_width">
          <span class="search_span_width_part1">&nbsp;&nbsp;语言：</span>
          <Select v-model="search.lang" clearable style="width:150px">
            <Option value="zh" >中文</Option>
            <Option value="en" >英文</Option>
          </Select>
	      </span>
            <Button type='primary' icon="ios-search" :style="{'margin-left':'20px'}" @click="getAppList(1)">搜索</Button>
          </Card>
          <Card id="producetListingContent">
            <Table :columns="producetListingColumns" :data="producet_listing_list"></Table>
            <Page :total="recordListingTotal" :current="listingPage" :page-size="10" :show-elevator="true" @on-change="listingProduct"/>
          </Card>
        </Card>
      </Content>
    </Modal>
    <Modal v-model="producetmodal" :footer-hide=true title="商品配置2" :width="70">
      <div class="box">
        <div >
          <p :style="{'margin':'5px 10px 10px 20px','clear':'both','overflow':'hidden'}">
          <span type='primary' :style="{'margin-left':'5px'}">已上架商品</span>
          </p>
          <Card id="producetListingContent">
            <Table :columns="producetListingColumns" :data="producet_listing_list"></Table>
            <Page :total="recordListingTotal" :current="listingPage" :page-size="10" :show-elevator="true" @on-change="listingProduct"/>
          </Card>
        </div>
        <div >
          <p :style="{'margin':'5px 10px 10px 20px','clear':'both','overflow':'hidden'}">
          <span type='primary' :style="{'margin-left':'5px'}">未上架商品</span>
          </p>
          <Card id="producetDelistContent">
            <Table :columns="producetDelistColumns" :data="producet_delist_list"></Table>
            <Page :total="recordDelistTotal" :current="delistPage" :page-size="10" :show-elevator="true" @on-change="delistProduct"/>
          </Card>
        </div>
      </div>
    </Modal>
    <Modal v-model="showsavemodal" :footer-hide=true title="配置商品":width="40">
      <Form ref="productAgentInfo" :model="productAgentInfo" :label-width="80" >
          <Input v-model="productAgentInfo.id" v-show="false" />
        <FormItem label="商品名称" prop="product_name">
          <Input v-model="productAgentInfo.product_name"  style="width:180px" disabled='disabled'/>
        </FormItem>
        <Row>
          <Col >
            <FormItem label="原价" prop="ori_total_fee">
              <Input v-model="productAgentInfo.ori_total_fee"  style="width:180px"/>
            </FormItem>
          </Col>
          <Col span="11">
            <FormItem label="渠道价" prop="total_fee">
              <Input v-model="productAgentInfo.total_fee"  style="width:180px"/>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col >
            <FormItem label="代理商级别" prop="grade_name_1">
              <Input v-model="productAgentInfo.grade_name_1"  disabled='disabled' style="width:180px"/>
            </FormItem>
          </Col>
          <Col span="11">
            <FormItem label="请输入结算价" prop="price_1">
              <Input v-model="productAgentInfo.price_1"  style="width:180px"/>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col>
            <FormItem label="代理商级别" prop="grade_name_2">
              <Input v-model="productAgentInfo.grade_name_2"  disabled='disabled' style="width:180px"/>
            </FormItem>
          </Col>
          <Col  span="11">
            <FormItem label="请输入结算价" prop="price_2">
              <Input v-model="productAgentInfo.price_2"  style="width:180px"/>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col >
            <FormItem label="代理商级别" prop="grade_name_3">
              <Input v-model="productAgentInfo.grade_name_3" disabled='disabled' value="三级代理商" style="width:180px"/>
            </FormItem>
          </Col>
          <Col span="11">
            <FormItem label="请输入结算价" prop="price_3">
              <Input v-model="productAgentInfo.price_3"  style="width:180px"/>
            </FormItem>
          </Col>
        </Row>
        <FormItem>
          <Button @click="closesavemodal" >取消</Button>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <Button type="primary" @click="updateProductAgent()" >上架</Button>
        </FormItem>
      </Form>
    </Modal>
    <Modal
        v-model="miniProductSettingShow"
        title="小程序配置">
      <Form :model="miniChannelSetting"  >
        <FormItem label="支付渠道" >
          <Select v-model="miniChannelSetting.pay_channel" style="width:200px">
            <Option v-for="item in channel_select" :value="item.id" :key="item.pay_channel">{{ item.name }}</Option>
          </Select>
        </FormItem>
        <FormItem label="小程序渠道">
          <Select v-model="miniChannelSetting.applet_channel" style="width:200px">
            <Option v-for="item in channel_select" :value="item.id" :key="item.id">{{ item.name }}</Option>
          </Select>
        </FormItem>
        <FormItem label="是否支持支付" prop="company_name">
          <RadioGroup v-model="miniChannelSetting.support_pay">
            <Radio label="1">是</Radio>
            <Radio label="0">否</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="是否支持用户首次扫码支付修改渠道和营销商" >
          <RadioGroup v-model="miniChannelSetting.support_change_userchannel">
            <Radio label="1">是</Radio>
            <Radio label="0">否</Radio>
          </RadioGroup>
        </FormItem>
      </Form>
      <template #footer>
        <Button @click="cancelMiniSetting">取消</Button>
        <Button type="primary" @click="handleMiniSetting">提交</Button>
      </template>
    </Modal>
  </Layout>
</template>
<script>
const OSS = require('ali-oss');
export default {
  data(){
    return {
      split: 0.5,
      search : {
        channel:'',
        status:0
      },
      listingSearch : {
        channel:'',
        is_listing:1
      },
      delistSearch : {
        channel:'',
        is_listing:1
      },
      produceInfo:{
        channel:'',
        product_id:0,
      },
      productAgentInfo:{
        id:0,
        product_id:0,
        product_name:"",
        channel:'',
        ori_total_fee:0,
        total_fee:0,
        details:'',
        is_listing:1,
        grade_1:1,
        grade_name_1:"一级代理商",
        price_1:0,
        grade_2:2,
        grade_name_2:"二级代理商",
        price_2:0,
        grade_3:3,
        grade_name_3:"三级代理商",
        price_3:0
      },
		showmodal:false,
    showsavemodal:false,
    miniProductSettingShow: false,
    miniChannelSetting:{
      id:0,
      pay_channel:"",
      applet_channel:"",
      support_pay:0,
      support_change_userchannel:''
    },
    recordTotal:0,
    currChannelName:'',
    page:1,
    listingPage:1,
    recordListingTotal:0,
    delistPage:1,
    recordDelistTotal:0,
		file:null,
    upLoadAgreementFile:null,
		loadingStatus:false,
    loadingStatusFile:false,
		upLoadProgress:0,
		upLoadProgress_show:false,
    upLoadAgreement:0,
    upLoadAgreement_show:false,
    producetListModal:false,
    producetmodal  :false,
		channel_list:[],
    producet_listing_list:[],
    producet_delist_list:[],
    channel_select:[],
    channel:{
      id:0,
      company_name:'',
      company_short_name:'',
      company_abbreviation:'',
      title:'',
      e_name:'',
      login_logo:'',
      logo:'',
      ico:'',
      mini_login_logo:'',
      mini_home_logo:'',
      user_agreement:'',
      private_agreement:'',
      voice_customized:'',
      script_url:'',
      knowledge_url:'',
      help:'',
      member_url:'',
      course_url:'',
      qycode:'',
      status:'1',
      seq:"0",
      indate_start:"",
      indate_end:"",
      admin_id:'0',
	  incharge:'',
      share_leftimg:'',
      share_cover:'',
      setting:'',
	  model_price:''
		},
      producetListingColumns:[
      { title: 'ID', key: 'product_id', align: 'center' },
      { title: '商品名称', key: 'product_name', align: 'center' },
      { title: '原价价格', key: 'ori_total_fee', align: 'center' },
      { title: '操作', key: 'action', align: 'center',
        render: (h, params) => {
          let btns=[]
          btns.push(
              h('Button', {
                props: { type: 'error', size: 'small' },
                style: { marginRight: '5px', marginBottom: '5px'},
                on: {
                  click: () => {
                    this.updateAgentListing(params.row.id,2);
                  }
                }
              }, '下架'),
          );
          return h("div",btns);
        },
      }
    ],
      producetDelistColumns:[
        { title: 'ID', key: 'id', align: 'center' },
        { title: '商品名称', key: 'product_name', align: 'center' },
        { title: '原价', key: 'ori_total_fee', align: 'center' },
        { title: '操作', key: 'action', align: 'center',
          render: (h, params) => {
            let btns=[]
            btns.push(
                h('Button', {
                  props: { type: 'error', size: 'small' },
                  style: { marginRight: '5px', marginBottom: '5px'},
                  on: {
                    click: () => {
                      this.produceInfo.product_id = params.row.id;
                      this.getProduct();
                      this.showsavemodal = true;
                    }
                  }
                }, '上架'),
            );
            return h("div",btns);
          },
        }
      ],
		tableColumns:[
      { title: '渠道ID', key: 'id', align: 'center' },
      { title: '渠道英文', key: 'e_name', align: 'center' },
		  { title: '渠道名称', key: 'title', align: 'center' },
      { title: '在售数量', key: 'product_num', align: 'center' },
      { title: '公司名称', key: 'company_name', align: 'center',
       render:(h,params) =>{
         var name = params.row.company_name;
          if (params.row.company_name == "") {
            name = params.row.company_short_name;
        }
        return h('span',{},name);
       }},
	   { title: '跟进人', key: 'incharge', align: 'center' },
      { title: '企业LOGO', key: 'cover', align: 'center',
        render:(h,params) =>{
        if(params.row.logo !=""){
          return h('img',{
            attrs : {src : params.row.logo},
            style : { width : '80px', height : '80px' }
          })
        }
        }},
      { title: '用户协议', key: 'user_agreement', align: 'center',
        render:(h,params) =>{
          var user_agreement = params.row.user_agreement;
          if (params.row.user_agreement != "") {
            return h('a',{
              attrs : {
                href : params.row.user_agreement
              }
            },'下载')
          }
        }},
      { title: '开始时间', key: 'indate_start', align: 'center' },
      { title: '结束时间', key: 'indate_end', align: 'center' },
		  { title: '创建时间', key: 'created_at', align: 'center' },
      { title: '操作', key: 'action', align: 'center',
        render: (h, params) => {
        let btns=[]
        btns.push(
          h('Button', {
            props: { type: 'warning', size: 'small' },
            style: { marginRight: '5px', marginBottom: '5px'},
            on: {
            click: () => {
              this.channel.id = params.row.id;
              this.channel.company_name = params.row.company_name;
              this.channel.company_short_name = params.row.company_short_name;
              this.channel.company_abbreviation = params.row.company_abbreviation;
              this.channel.title = params.row.title;
              this.channel.e_name = params.row.e_name;
              this.channel.login_logo = params.row.login_logo;
              this.channel.logo = params.row.logo;
              this.channel.ico = params.row.ico;
              this.channel.mini_login_logo = params.row.mini_login_logo;
              this.channel.mini_home_logo = params.row.mini_home_logo;
              this.channel.user_agreement = params.row.user_agreement;
              this.channel.private_agreement = params.row.private_agreement;
              this.channel.voice_customized = params.row.voice_customized;
              this.channel.script_url = params.row.script_url;
              this.channel.knowledge_url = params.row.knowledge_url;
              this.channel.help = params.row.help;
              this.channel.member_url = params.row.member_url;
              this.channel.course_url = params.row.course_url;
              this.channel.qycode = params.row.qycode;
              this.channel.status = params.row.status;
              this.channel.admin_id = params.row.admin_id;
              this.channel.indate_start = params.row.indate_start;
              this.channel.indate_end = params.row.indate_end;
              this.channel.share_leftimg = params.row.share_leftimg;
              this.channel.share_cover = params.row.share_cover;
              this.channel.setting=params.row.setting;
			  this.channel.incharge = params.row.incharge;
			  this.channel.model_price = params.row.model_price;
			  this.showmodal = true;
            }
            }
          }, '编辑'),
        );
        btns.push(
            h('Button', {
              props: { type: 'warning', size: 'small' },
              style: { marginRight: '5px', marginBottom: '5px'},
              on: {
                click: () => {
                  this.delChannel(params.row.id);
                }
              }
            }, '删除'),
        );
        btns.push(
            h('Button', {
              props: { type: 'primary', size: 'small' },
              style: { marginRight: '5px', marginBottom: '5px'},
              on: {
                click: () => {
                  this.miniProductSettingShow = true;
                  this.miniChannelSetting.id = params.row.id;
                  this.miniChannelSetting.pay_channel = params.row.pay_channel;
                  this.miniChannelSetting.applet_channel=params.row.applet_channel;
                  this.miniChannelSetting.support_pay=params.row.support_pay;
                  this.miniChannelSetting.support_change_userchannel = params.row.support_change_userchannel
                }
              }
            }, '小程序配置'),
        );
          btns.push(
              h('Button', {
                props: { type: 'error', size: 'small' },
                style: { marginRight: '5px', marginBottom: '5px'},
                on: {
                  click: () => {
                    this.$router.push('/channel/producetList?channel='+params.row.e_name);
  /*                  this.producetListModal = true;
                    //this.producetmodal = true;
                    this.listingSearch.channel = params.row.e_name;
                    this.delistSearch.channel = params.row.e_name;
                    this.produceInfo.channel = params.row.e_name;
                    this.listingProduct();*/
                    //this.delistProduct();
                  }
                }
              }, '商品配置'),
          );
        return h("div",btns);
        },
      }
		],
    uploadHeader:{
      "Authorization":localStorage.getItem('token')
    },
	}
  },
  mounted:function(){
    this.getChannelList();
    this.getChannelSelect();
  },
  computed:{
    getUploadUrl(){
      return process.env.VUE_APP_APIHOST+'/admin/channel/upload';
    },
  },
  methods:{
    addChannel(){
      this.channel.id = 0;
      this.channel.company_name = "",
      this.channel.company_short_name = "",
      this.channel.company_abbreviation = "",
      this.channel.title = "",
      this.channel.e_name = "",
      this.channel.login_logo = "",
      this.channel.logo = "",
      this.channel.ico = "",
      this.channel.mini_login_logo = "",
      this.channel.mini_home_logo = "",
      this.channel.user_agreement = "",
      this.channel.private_agreement = "",
      this.channel.voice_customized = "",
      this.channel.script_url = "",
      this.channel.knowledge_url = "",
      this.channel.help = "",
      this.channel.member_url = "",
      this.channel.course_url = "",
      this.channel.qycode = "",
      this.channel.status = 1,
      this.channel.admin_id = 0,
          this.channel.indate_start = '',
          this.channel.indate_end ='',
		  this.channel.incharge = '',
		  this.channel.setting = '',
		  this.channel.model_price = '',
      this.showmodal = true;
	  },
	handleUpload (file) {
	  this.file = file;
	  return false;
	},
  handleAgreementUpload (file) {
    this.upLoadAgreementFile = file;
    return false;
  },
  getChannelList(page=this.page) {
      this.page = page;
      let p = {'page' : page}
      let params = Object.assign(this.search, p);
      this.http.get('/admin/channel/channelList',{params:params}).then(response=>{
        let data=response.data;
        if(data.code!==0){
          alert(data.message);
        } else{
          this.channel_list = data.data.list;
          this.recordTotal = data.data.total;
        }
      }).catch(()=>{
        this.$Message.error('网络错误');
      });
    },
	updateChannel(){
		this.http.post('/admin/channel/saveChannel',this.channel).then(response=>{
		  let data=response.data;
		  if(data.code!==0) {
		    this.$Message.error(data.message);
		    return false;
		  } else{
		    this.$Message.info(data.message);
		    this.showmodal = false;
			  this.getChannelList();
		    return true;
		  }
		});
	},
  delChannel(channel_id){//删除渠道
    this.$Modal.confirm({
      content: '<p>确定删除？</p>',
      onOk: () => {
        this.showAllmodal = false;
        this.http.post('/admin/channel/delChannel',{channel_id:channel_id}).then(response=>{
          let data=response.data;
          if(data.code!==0) {
            this.$Message.error(data.message);
            return false;
          } else{
            this.$Message.info(data.message);
            this.getChannelList(this.page);
            return true;
          }
        });
      },
/*      onCancel: () => {
      }*/
    });
  },
  listingProduct(page=this.listingPage){
    let p = {'page' : page}
    let params = Object.assign(this.delistSearch, p);
    this.http1.get('/produce/producetList',{params:params}).then(response=>{
      let data=response.data;
      if(data.code!==0) {
        this.$Message.error(data.message);
        return false;
      } else{
        this.producet_listing_list = data.data.list;
        this.recordListingTotal = data.data.total;
        //alert(this.producet_listing_list[0].id);
     //   return true;
      }
    });
  },
  delistProduct(page=this.delistPage){
    let p = {'page' : page}
    let params = Object.assign(this.listingSearch, p);
    this.http.get('/admin/product/delistProduct',{params:params}).then(response=>{
      let data=response.data;
      if(data.code!==0) {
        this.$Message.error(data.message);
        return false;
      } else{
        this.producet_delist_list = data.data.list;
        this.recordDelistTotal = data.data.total;
        //alert(this.producet_listing_list[0].id);
        //   return true;
      }
    });
  },
  getProduct(){
    this.http.get('/admin/product/getProductInfo',{params:this.produceInfo}).then(response=>{
      let data=response.data;
      if(data.code!==0) {
        this.$Message.error(data.message);
        return false;
      } else{
        this.productAgentInfo.id = data.data.id;
        this.productAgentInfo.product_id = data.data.product_id;
        this.productAgentInfo.product_name = data.data.product_name;
        this.productAgentInfo.price_1 = data.data.price_1;
        this.productAgentInfo.price_2 = data.data.price_2;
        this.productAgentInfo.price_3 = data.data.price_3;
      }
    });
  },
  updateProductAgent() {
  this.http.post('/admin/product/updateProductAgent',this.productAgentInfo).then(response=>{
    let data=response.data;
    if(data.code!==0)
    {
      alert(data.message);
    } else{
      this.$Message.success('操作成功');
      this.listingProduct();
      this.delistProduct();
      this.showsavemodal=false;
      return true
    }
  }).catch(()=>{
    this.$Message.error('网络错误');
  });
},
  updateAgentListing(id,status){
    this.http.post('/admin/product/updateProductAgentListing',{id:id,status:status}).then(response=>{
      let data=response.data;
      if(data.code!==0) {
        this.$Message.error(data.message);
        return false;
      } else{
        //this.producetmodal = true;
        this.listingProduct();
        this.delistProduct();
        return true;
      }
    });
  },
  doAgreementUpload(){
    this.http.get('/admin/material/getUpoadVideoToken').then(response=>{
      let data=response.data;
      console.log(data);
      if(data.StatusCode!=200){
        this.$Message.error(data.message);
      } else {
        const config = data;
        console.log(config);

        const ossClient = new OSS({
          accessKeyId: config.AccessKeyId,
          accessKeySecret: config.AccessKeySecret,
          stsToken: config.SecurityToken,
          bucket:config.bucket,
          region:config.RegionId,
          secure:true,
          endpoint:'oss-cn-zhangjiakou.aliyuncs.com'
        });

        const fileName = this.upLoadAgreementFile.name;
        //const fileName = '风平IP智造'+this.app.app_version+'.exe'

        const progress = (p, _checkpoint) => {
          // Object的上传进度。
          this.upLoadAgreement_show = true;
          this.upLoadAgreement= parseInt(p*100);
          //console.log(p);
          // 分片上传的断点信息。
          //console.log(_checkpoint);
        };

        ossClient.multipartUpload('freefishpc/channel/doc/'+fileName, this.upLoadAgreementFile,{progress}).then(
            result => {
              this.upLoadAgreementFile = null;
              this.channel.user_agreement = result.name;
              console.log(`channel upload ${fileName} succeeded, result === `, result)
            }).catch(
            err => {
              console.log(`channel upload ${fileName} failed === `, err);
            });
      }
    }).catch(()=>{
      this.$Message.error('网络错误');
    });
  },
	doUpload() {
	  	this.http.get('/admin/material/getUpoadVideoToken').then(response=>{
			let data=response.data;
			console.log(data);
			if(data.StatusCode!=200){
				this.$Message.error(data.message);
			} else {
				const config = data;
				console.log(config);
	
				const ossClient = new OSS({
					accessKeyId: config.AccessKeyId,
					accessKeySecret: config.AccessKeySecret,
					stsToken: config.SecurityToken,
					bucket:config.bucket,
					region:config.RegionId,
					secure:true,
					endpoint:'oss-cn-zhangjiakou.aliyuncs.com'
				});
				
				const fileName = this.file.name;  
				//const fileName = '风平IP智造'+this.app.app_version+'.exe'
				 
				 const progress = (p, _checkpoint) => {
				   // Object的上传进度。
				   this.upLoadProgress_show = true;
				   this.upLoadProgress = parseInt(p*100);
				   //console.log(p); 
				   // 分片上传的断点信息。
				   //console.log(_checkpoint); 
				 };
				 
				ossClient.multipartUpload('freefishpc/channel/doc/'+fileName, this.file,{progress}).then(
					result => {     
						this.file = null;
						this.channel.private_agreement = result.name;
						console.log(`channel upload ${fileName} succeeded, result === `, result)
					}).catch(
						err => {     
							console.log(`channel upload ${fileName} failed === `, err);
					}); 
			}
	  	}).catch(()=>{
	  	  this.$Message.error('网络错误');
	  	});
	},
    successLoginLogo(response){
      let data=response
      if(data.code!=0) {
        this.$Message.error(data.message);
        return true;
      }
      this.channel.login_logo = data.data.url;
      this.$Message.success('上传成功');
    },
    successLogo(response){
      let data=response
      if(data.code!=0) {
        this.$Message.error(data.message);
        return true;
      }
      this.channel.logo = data.data.url;
      this.$Message.success('上传成功');
    },
    successIco(response){
      let data=response
      if(data.code!=0) {
        this.$Message.error('上传成功');
        return true;
      }
      this.channel.ico = data.data.url;
      this.$Message.success('上传成功');
    },
    successMiniLoginLogo(response){
      let data=response
      if(data.code!=0) {
        this.$Message.error('上传成功');
        return true;
      }
      this.channel.mini_login_logo = data.data.url;
      this.$Message.success('上传成功');
    },
    successMiniHomeLogo(response){
      let data=response
      if(data.code!=0) {
        this.$Message.error('上传成功');
        return true;
      }
      this.channel.mini_home_logo = data.data.url;
      this.$Message.success('上传成功');
    },
    successShareLeft(response){
      let data=response
      if(data.code!=0) {
        this.$Message.error('上传成功');
        return true;
      }
      this.channel.share_leftimg = data.data.url;
      this.$Message.success('上传成功');
    },
    successShareCover(response){
      let data=response
      if(data.code!=0) {
        this.$Message.error('上传成功');
        return true;
      }
      this.channel.share_cover = data.data.url;
      this.$Message.success('上传成功');
    },
    closesavemodal(){
		this.showsavemodal=false;
    },

    getChannelSelect() {
      this.http.get('/admin/common/getChannelList').then(response=>{
        let data=response.data;
        if(data.code!==0){
          alert(data.message);
        } else{
          this.channel_select = data.data;
        }
      }).catch(()=>{
        this.$Message.error('网络错误');
      });
    },
    handleMiniSetting(){
      this.http.post('/admin/channel/updatePayChannel',this.miniChannelSetting).then(response=>{
        let data=response.data;
        if(data.code!==0) {
          this.$Message.error(data.message);
          return false;
        } else{
          this.$Message.success("编辑成功");
          this.getChannelList();
          this.miniProductSettingShow = false
          return true;
        }
      });
    },
    cancelMiniSetting(){
      this.miniProductSettingShow = false
    }
  }

}
</script>
<style>
.producetsplit{
  height: 200px;
  border: 1px solid #dcdee2;
}
.demo-split-pane{
  padding: 10px;
}
</style>

<style lang='postcss'>
.box {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
}
.box > div {
  height: 100%;
  flex: 1;
}
</style>